module.exports = __webpack_public_path__ + "img/recharge.f806cd7e.svg";